<template>
  <div
    v-if="value"
    v-loading="loading && !value.acceptRules && !value.acceptReponsability"
    class="tournament-light-grey rounded pa-4"
    element-loading-text="Carregando..."
  >
    <div
      v-if="value && value.acceptRules"
      class="row align-center"
      style="height: 36px"
    >
      <v-checkbox
        v-model="value.acceptRules._id"
        class="no-flex pa-0 mt-0"
        value="true"
        style="height: 24px"
        color="tournament-green"
        :disabled="!isEditable"
        @change="updateDocuments()"
      />
      <div class="ml-2 tournament-dark-blue--text column flex">
        <div class="row">
          <div class="mr-2" v-if="community === 'fll-open-brazil'">
            I declare that I am aware of and agree with
            <a
              class="tournament-light-blue--text underline"
              target="_blank"
              :href="season.acceptRules"
            >
              {{ season.name }} - {{ season.year }} Rules
            </a>
            and
            <a
              class="tournament-light-blue--text underline"
              target="_blank"
              href="https://link.layers.education/open-termo1"
            >
              Terms
            </a>
            .
          </div>
          <div class="column mr-2" v-else>
            Declaro estar ciente das
            <a
              class="tournament-light-blue--text underline column"
              :href="season.acceptRules"
              target="_blank"
            >Regras da {{ season.name }} - {{ season.year }}</a>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="value && value.acceptReponsability && kind !== 'judge'"
      class="row align-center mt-4"
      style="min-height: 36px"
    >
      <v-checkbox
        v-model="value.acceptReponsability._id"
        class="no-flex pa-0 mt-0"
        value="true"
        style="height: 40px"
        color="tournament-green"
        :disabled="!isEditable"
        @change="updateDocuments()"
      />
      <div class="ml-2 tournament-dark-blue--text column flex">
        <div class="row">
          <div class="column mr-2">
            Declaro ser o técnico da equipe e estar ciente das responsabilidades
            decorrentes da inscrição da equipe no Torneio de Robótica
            {{ tournamentName }}.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import getCurrentSeason from "@/helpers/events/getCurrentSeason";

export default {
  name: "EnrollmentSubmitTerms",

  computed: {
    ...mapState(["community"]),

    tournamentName() {
      return this.community.split("-")[0].toUpperCase();
    },

    season() {
      return getCurrentSeason(this.community);
    },
  },

  props: {
    value: {
      type: Object,
    },
    enrollmentStatus: {
      type: String,
    },
    kind: {
      type: String,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    };
  },

  created() {
    // Keep safe when parent pass a undefined as prop
    if (!this.value) {
      return this.$emit("input", {
        acceptReponsability: {},
        acceptRules: {},
      });
    }
  },

  methods: {
    updateDocuments() {
      const localValue = _.cloneDeep(this.value);
      this.$emit("input", localValue);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Enrollments/Submit/Terms.vue